<template>
  <div class="certificate-modern">
    <div class="certificate-container">
      <!-- Main Configuration Card -->
      <div v-if="permission('read', 'user_certificate')" class="config-card">
        <div class="card-header">
          <div class="header-icon">
            <i class="fas fa-certificate"></i>
          </div>
          <div class="header-content">
            <h3 class="card-title">Configuração de Certificado Digital</h3>
            <p class="card-subtitle">
              Configure o uso de certificado digital para assinatura eletrônica
            </p>
          </div>
        </div>

        <div class="card-content">
          <!-- Warning Alert -->
          <div class="warning-alert">
            <div class="alert-icon">
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div class="alert-content">
              <h4 class="alert-title">Atenção</h4>
              <p class="alert-text">
                Ao habilitar o uso do certificado, não será possível reverter o
                processo!
              </p>
            </div>
          </div>

          <!-- Configuration Form -->
          <div class="form-section">
            <div class="form-group">
              <label class="form-label">
                <i class="fas fa-toggle-on mr-2"></i>
                Ativar uso do certificado digital
                <span class="required-indicator">*</span>
              </label>
              <div class="input-group">
                <div class="select-wrapper">
                  <select class="form-select" v-model="use_certificate">
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                  <div class="select-icon">
                    <i class="fas fa-chevron-down"></i>
                  </div>
                </div>
                <div class="action-button">
                  <ConfirmationDialog
                    :disabled="loading"
                    open-text="Salvar"
                    headerClass="modal-header-ok"
                    message-title="Confirmar Configuração"
                    message-body="Deseja realmente salvar esta configuração?"
                    open-class="btn-save-modern"
                    open-left-icon="fa-save"
                    @yes="execute"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Certificate Issuance Card -->
      <div
        v-if="user_id == loggedin_user_id && use_certificate == 1"
        class="config-card"
      >
        <div class="card-header">
          <div class="header-icon issuance-icon">
            <i class="fas fa-id-card"></i>
          </div>
          <div class="header-content">
            <h3 class="card-title">Solicitar Emissão do Certificado Digital</h3>
            <p class="card-subtitle">
              Solicite a emissão do certificado digital para assinatura
              eletrônica
            </p>
          </div>
        </div>

        <div class="card-content">
          <!-- Warning Alert -->
          <div class="info-alert">
            <div class="alert-icon">
              <i class="fas fa-info-circle"></i>
            </div>
            <div class="alert-content">
              <h4 class="alert-title">Informação</h4>
              <p class="alert-text">
                Após o certificado emitido, é válido por <strong>1 ANO</strong>!
              </p>
            </div>
          </div>

          <div v-if="user_bry_certificate">
            <CertificateBRyResult
              :user_bry_certificate="user_bry_certificate"
            />
          </div>

          <!-- Success State -->
          <div
            v-if="
              user_bry_certificate && user_bry_certificate.result != 'approved'
            "
            class="warning-alert-new-certificate"
          >
            <ConfirmationDialog
              :disabled="loading"
              open-text="Solicitar Nova Emissão"
              headerClass="modal-header-ok"
              message-title="Confirmar"
              message-body="Deseja realmente solicitar uma nova emissão de certificado? Ao solicitar, será gerado um novo protocolo!"
              open-class="btn-modern btn-renew-modern"
              open-left-icon="fa-redo"
              @yes="certificateIssuanceRequest"
            />
          </div>

          <div
            v-if="
              user_bry_certificate && user_bry_certificate.result == 'approved'
            "
            class="success-alert"
          >
            <div class="success-actions">
              <ConfirmationDialog
                :disabled="loading"
                open-text="Solicitar Nova Emissão"
                headerClass="modal-header-ok"
                message-title="Confirmar"
                message-body="Deseja realmente solicitar uma nova emissão de certificado? Ao solicitar, será gerado um novo protocolo!"
                open-class="btn-modern btn-renew-modern"
                open-left-icon="fa-redo"
                @yes="certificateIssuanceRequest"
              />
            </div>
          </div>

          <!-- App Installation Guide -->
          <div class="app-guide-card">
            <div class="guide-header">
              <div class="guide-icon">
                <i class="fas fa-mobile-alt"></i>
              </div>
              <div class="guide-content">
                <h4 class="guide-title">Aplicativo SYN</h4>
                <p class="guide-text">
                  Após a solicitação da emissão do certificado, você precisará
                  instalar o aplicativo SYN no seu celular para realizar a
                  videoconferência
                </p>
              </div>
            </div>
            <div class="guide-actions">
              <a
                class="btn-app-link"
                href="https://meusyn.com.br/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="fas fa-external-link-alt mr-2"></i>
                Acessar SYN
              </a>
            </div>
          </div>

          <!-- Video Conference Status -->
          <div
            v-if="
              protocol &&
              (!user_bry_certificate ||
                !['approved'].includes(user_bry_certificate.result))
            "
            class="conference-card"
          >
            <div class="conference-header">
              <div class="conference-icon">
                <i class="fas fa-video"></i>
              </div>
              <div class="conference-content">
                <h4 class="conference-title">Videoconferência</h4>
                <p class="conference-text">
                  Caso já tenha feito a videoconferência, clique no botão para
                  copiar o link do atendimento
                </p>
              </div>
            </div>
            <div class="conference-actions">
              <button class="btn-modern btn-conference-link" @click="copyLink">
                <i class="fas fa-copy mr-2"></i>
                Copiar link da videoconferência
              </button>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="actions-section">
            <div class="actions-grid">
              <ConfirmationDialog
                v-if="
                  protocol &&
                  (!user_bry_certificate ||
                    !['approved'].includes(user_bry_certificate.result))
                "
                :disabled="loading"
                open-text="Consultar Status"
                headerClass="modal-header"
                message-title="Confirmar"
                message-body="Deseja realmente consultar o status da emissão do certificado?"
                open-class="btn-modern btn-status-modern"
                open-left-icon="fa-search"
                @yes="certificateIssuanceRequestStatus"
              />

              <ConfirmationDialog
                v-if="!protocol && !user_bry_certificate"
                :disabled="loading"
                open-text="Solicitar Emissão"
                headerClass="modal-header-ok"
                message-title="Confirmar"
                message-body="Deseja realmente solicitar a emissão do certificado?"
                open-class="btn-modern btn-modern-add"
                open-left-icon="fa-id-card"
                @yes="certificateIssuanceRequest"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Errors Section -->
      <div v-if="errors.length > 0">
        <ErrorsMessages :errors="errors" />
      </div>

      <!-- Information Card -->
      <div class="info-card">
        <div class="info-header">
          <div class="info-header-icon">
            <i class="fas fa-lightbulb"></i>
          </div>
          <h4 class="info-title">Sobre Certificados Digitais</h4>
        </div>
        <div class="info-content">
          <div class="info-grid">
            <div class="info-item">
              <div class="item-icon security-icon">
                <i class="fas fa-shield-alt"></i>
              </div>
              <div class="item-content">
                <h5 class="item-title">Segurança</h5>
                <p class="item-text">
                  Garante autenticidade e integridade dos documentos
                </p>
              </div>
            </div>

            <div class="info-item">
              <div class="item-icon legal-icon">
                <i class="fas fa-balance-scale"></i>
              </div>
              <div class="item-content">
                <h5 class="item-title">Validade Jurídica</h5>
                <p class="item-text">
                  Possui valor legal equivalente à assinatura manuscrita
                </p>
              </div>
            </div>

            <div class="info-item">
              <div class="item-icon efficiency-icon">
                <i class="fas fa-clock"></i>
              </div>
              <div class="item-content">
                <h5 class="item-title">Eficiência</h5>
                <p class="item-text">
                  Agiliza processos e elimina a necessidade de documentos
                  físicos
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import CertificateBRyResult from "./certificate/result";

import permission from "../../lib/permission";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import { userData } from "../../lib/functions";

export default {
  name: "Certificate",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    CertificateBRyResult,
  },

  props: {
    user_id: { type: [Number, String] },
    use_certificate: { type: [Number, String, Boolean] },
    protocol: { type: [Number, String, Boolean] },
    cpf: { type: [Number, String, Boolean] },
    user_bry_certificate: { type: [Number, String, Boolean, Object] },
  },

  data() {
    return {
      loggedin_user_id: null,
      allow: 0,
      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    retrieve() {
      this.allow = this.use_certificate;

      let { id: loggedin_user_id } = userData().user;

      this.loggedin_user_id = loggedin_user_id;
    },

    async execute() {
      try {
        this.loading = true;

        let { user_id, use_certificate } = this;
        let params = { user_id, use_certificate };

        const response = await api.put(
          "/rest-home/user/use-certificate",
          params
        );
        const { error, errors, message } = response.data;

        if (!error) {
          this.$emit("save");
          toast(message, "success");
          this.errors = [];
          this.allow = this.use_certificate;
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async certificateIssuanceRequest() {
      try {
        this.loading = true;

        let { user_id } = this;
        let params = { user_id };

        const response = await api.post(
          "/bry/user/certificate-issuance-request",
          params
        );
        const { error, errors, message } = response.data;

        if (!error) {
          this.$emit("save");
          toast(message, "success");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async certificateIssuanceRequestStatus() {
      try {
        this.loading = true;

        let { user_id } = this;
        let params = { user_id };

        const response = await api.post(
          "/bry/user/certificate-issuance-request-status",
          params
        );
        const { error, errors, message } = response.data;

        if (!error) {
          this.$emit("save");
          toast(message, "success");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    copyLink() {
      let copy = `https://certificaminas.syngularid.com.br/lyve?protocolo=${
        this.protocol
      }&cpf=${String(this.cpf)
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")}`;

      navigator.clipboard.writeText(copy);
    },
  },
};
</script>

<style scoped>
.certificate-modern {
  min-height: 100vh;
}

.certificate-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0 auto;
}

/* Card Base Styles */
.config-card,
.info-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  transition: all 0.3s ease;
}

.config-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

/* Card Headers */
.card-header {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  overflow: hidden;
}

.card-header::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  transform: rotate(45deg);
  animation: shimmer 3s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) rotate(45deg);
  }
}

.header-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.issuance-icon {
  background: linear-gradient(
    135deg,
    rgba(16, 185, 129, 0.3) 0%,
    rgba(5, 150, 105, 0.3) 100%
  );
  border-color: rgba(16, 185, 129, 0.4);
}

.header-content {
  flex: 1;
  color: white;
}

.card-title {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 6px 0;
}

.card-subtitle {
  font-size: 14px;
  opacity: 0.9;
  margin: 0;
  line-height: 1.5;
}

/* Card Content */
.card-content {
  padding: 32px 24px;
}

/* Alert Styles */
.warning-alert-new-certificate {
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  backdrop-filter: blur(10px);
}

.warning-alert,
.info-alert,
.success-alert {
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  backdrop-filter: blur(10px);
}

.warning-alert,
.warning-alert-new-certificate {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  border: 1px solid #f59e0b;
}

.info-alert {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  border: 1px solid #3b82f6;
}

.success-alert {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border: 1px solid #10b981;
  flex-direction: column;
  align-items: stretch;
  gap: 20px;
}

.alert-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.warning-alert .alert-icon {
  background: rgba(217, 119, 6, 0.2);
  color: #d97706;
}

.info-alert .alert-icon {
  background: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.success-alert .success-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(16, 185, 129, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #10b981;
  font-size: 20px;
  align-self: center;
}

.alert-content,
.success-content {
  flex: 1;
}

.alert-title,
.success-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 6px 0;
}

.warning-alert .alert-title {
  color: #92400e;
}

.info-alert .alert-title {
  color: #1e40af;
}

.success-alert .success-title {
  color: #065f46;
  text-align: center;
  font-size: 18px;
}

.alert-text,
.success-text {
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

.warning-alert .alert-text {
  color: #92400e;
}

.info-alert .alert-text {
  color: #1e40af;
}

.success-alert .success-text {
  color: #065f46;
  text-align: center;
}

.success-actions {
  display: flex;
  justify-content: center;
}

/* Form Section */
.form-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
}

.required-indicator {
  color: #ef4444;
  margin-left: 4px;
}

.input-group {
  display: flex;
  gap: 16px;
  align-items: stretch;
}

/* Select Wrapper */
.select-wrapper {
  position: relative;
  flex: 1;
}

.form-select {
  width: 100%;
  padding: 14px 48px 14px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background: #f9fafb;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  appearance: none;
  transition: all 0.3s ease;
}

.form-select:focus {
  outline: none;
  border-color: #0f65b0;
  background: white;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
}

.select-icon {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
  font-size: 14px;
  transition: all 0.3s ease;
}

.form-select:focus + .select-icon {
  color: #0f65b0;
}

/* Guide and Conference Cards */
.app-guide-card,
.conference-card {
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}

.guide-header,
.conference-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
}

.guide-icon,
.conference-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: white;
}

.guide-icon {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
}

.conference-icon {
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
}

.guide-content,
.conference-content {
  flex: 1;
}

.guide-title,
.conference-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 6px 0;
}

.guide-text,
.conference-text {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}

.guide-actions,
.conference-actions {
  display: flex;
  justify-content: center;
}

/* Button Styles */
.btn-save-modern,
.btn-renew-modern,
.btn-status-modern,
.btn-issue-modern,
.btn-app-link,
.btn-conference-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.btn-save-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
}

.btn-renew-modern {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  color: white !important;
}

.btn-status-modern {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%) !important;
  color: white !important;
}

.btn-issue-modern {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
}

.btn-app-link {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
}

.btn-conference-link {
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
  color: white;
}

.btn-save-modern:hover:not(:disabled),
.btn-renew-modern:hover:not(:disabled),
.btn-status-modern:hover:not(:disabled),
.btn-issue-modern:hover:not(:disabled),
.btn-app-link:hover,
.btn-conference-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.btn-save-modern:disabled,
.btn-renew-modern:disabled,
.btn-status-modern:disabled,
.btn-issue-modern:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

/* Actions Section */
.actions-section {
  margin-top: 24px;
}

.actions-grid {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

/* Information Card */
.info-card {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #7dd3fc;
}

.info-header {
  background: linear-gradient(135deg, #0369a1 0%, #0c4a6e 100%);
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
}

.info-header-icon {
  font-size: 20px;
}

.info-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.info-content {
  padding: 24px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  border: 1px solid #e0f2fe;
  transition: all 0.3s ease;
}

.info-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.item-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: white;
  flex-shrink: 0;
}

.security-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.legal-icon {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.efficiency-icon {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
}

.item-content {
  flex: 1;
}

.item-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 6px 0;
}

.item-text {
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .certificate-container {
    gap: 20px;
    padding: 0 16px;
  }

  .card-header {
    padding: 20px;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
  }

  .header-icon {
    width: 48px;
    height: 48px;
    font-size: 20px;
  }

  .card-content {
    padding: 24px 20px;
  }

  .input-group {
    flex-direction: column;
    gap: 12px;
  }

  .actions-grid {
    flex-direction: column;
    align-items: center;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .warning-alert,
  .info-alert {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
  }

  .guide-header,
  .conference-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .certificate-modern {
    padding: 16px 0;
  }

  .certificate-container {
    padding: 0 12px;
  }

  .card-header {
    padding: 16px;
  }

  .card-content {
    padding: 20px 16px;
  }

  .card-title {
    font-size: 18px;
  }

  .warning-alert,
  .info-alert,
  .app-guide-card,
  .conference-card {
    padding: 16px;
  }

  .alert-icon,
  .guide-icon,
  .conference-icon {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }

  .info-header {
    padding: 16px 20px;
  }

  .info-content {
    padding: 20px;
  }

  .info-item {
    padding: 16px;
  }

  .item-icon {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }

  .btn-save-modern,
  .btn-renew-modern,
  .btn-status-modern,
  .btn-issue-modern,
  .btn-app-link,
  .btn-conference-link {
    padding: 10px 16px;
    font-size: 13px;
  }
}

/* Loading States */
.loading-overlay {
  position: relative;
}

.loading-overlay::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  z-index: 10;
}

/* Accessibility Improvements */
.form-select:focus,
.btn-save-modern:focus,
.btn-renew-modern:focus,
.btn-status-modern:focus,
.btn-issue-modern:focus {
  outline: 2px solid #0f65b0;
  outline-offset: 2px;
}

/* Animation for card entrance */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.config-card,
.info-card {
  animation: slideInUp 0.6s ease-out;
}

.config-card:nth-child(2) {
  animation-delay: 0.2s;
}

.info-card {
  animation-delay: 0.4s;
}

/* Status indicators */
.status-indicator {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-success {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.status-pending {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  color: #d97706;
  border: 1px solid #f59e0b;
}

.status-error {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  border: 1px solid #f87171;
}

/* Micro-interactions */
.card-header:hover .header-icon {
  transform: scale(1.05);
}

.info-item:hover .item-icon {
  transform: scale(1.1);
}

.btn-save-modern:active,
.btn-renew-modern:active,
.btn-status-modern:active,
.btn-issue-modern:active {
  transform: translateY(0) scale(0.98);
}

/* Focus indicators for better accessibility */
.form-select:focus-visible,
.btn-save-modern:focus-visible,
.btn-renew-modern:focus-visible,
.btn-status-modern:focus-visible,
.btn-issue-modern:focus-visible,
.btn-app-link:focus-visible,
.btn-conference-link:focus-visible {
  outline: 3px solid rgba(15, 101, 176, 0.5);
  outline-offset: 2px;
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .card-header {
    background: #1e293b;
  }

  .warning-alert {
    background: #fbbf24;
    color: #000;
  }

  .info-alert {
    background: #3b82f6;
    color: #fff;
  }

  .success-alert {
    background: #10b981;
    color: #fff;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }

  .card-header::before {
    animation: none;
  }
}

/* Print styles */
@media print {
  .certificate-modern {
    background: white;
    padding: 0;
  }

  .config-card,
  .info-card {
    box-shadow: none;
    border: 1px solid #ccc;
    page-break-inside: avoid;
  }

  .card-header {
    background: #f5f5f5 !important;
    color: #000 !important;
  }

  .btn-save-modern,
  .btn-renew-modern,
  .btn-status-modern,
  .btn-issue-modern,
  .btn-app-link,
  .btn-conference-link {
    display: none;
  }
}

/* Dark mode support (future-proofing) */
@media (prefers-color-scheme: dark) {
  .certificate-modern {
    background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  }

  .config-card,
  .info-card {
    background: #1e293b;
    border-color: #374151;
  }

  .card-content {
    color: #e5e7eb;
  }

  .form-select {
    background: #374151;
    color: #e5e7eb;
    border-color: #4b5563;
  }

  .app-guide-card,
  .conference-card {
    background: #374151;
    border-color: #4b5563;
  }
}

/* Utility classes for additional styling */
.text-center {
  text-align: center;
}

.mb-2 {
  margin-bottom: 8px;
}

.mb-5 {
  margin-bottom: 20px;
}

.mr-2 {
  margin-right: 8px;
}

.p-3 {
  padding: 12px;
}

.border {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

/* Loading spinner for buttons */
.btn-loading {
  position: relative;
  pointer-events: none;
}

.btn-loading::after {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  margin: auto;
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Tooltip styles for enhanced UX */
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-wrapper:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #1f2937;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  margin-bottom: 8px;
}

.tooltip-wrapper:hover::before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #1f2937;
  z-index: 1000;
  margin-bottom: 2px;
}

/* Enhanced error styling */
.errors-section {
  position: relative;
  overflow: hidden;
}

.errors-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #ef4444 0%, #dc2626 100%);
}

/* Custom scrollbar for webkit browsers */
.card-content::-webkit-scrollbar {
  width: 8px;
}

.card-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.card-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.card-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Enhanced form validation styles */
.form-select.error {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.form-select.success {
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

/* Progress indicators */
.progress-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px 0;
}

.progress-step {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  background: #e5e7eb;
  color: #6b7280;
}

.progress-step.active {
  background: #0f65b0;
  color: white;
}

.progress-step.completed {
  background: #10b981;
  color: white;
}

.progress-line {
  flex: 1;
  height: 2px;
  background: #e5e7eb;
  position: relative;
}

.progress-line.completed::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: #10b981;
}
</style>